import inlineEditable from './inlineEditable';
import FinalFormWrapper from './finalFormWrapper';

export { FinalFormWrapper, inlineEditable };
export default { FinalFormWrapper, inlineEditable };
